import styled from 'styled-components';
import Button from 'components/Core/Button';

const StyledButton = styled(Button)`
  box-shadow: none;
  margin-top: 10px;
  padding: 10px 24px;

  p {
    color: var(--white);
    font-weight: bold;
    margin: 0;
  }
`;

export { StyledButton };
